// import React, { useContext, useEffect, useRef, useState } from "react";
// import { TableRowColumnIndexContex } from "../../../context/TableRowColumnIndexContex";
// import { DatabaseDropdownContext } from "../../../context/DatabaseDropdownContext";

// export default function TableComponent({ tableData, onUpdateTable }) {
//   const { setIndexRow, setIndexColumn } = useContext(TableRowColumnIndexContex);

//   const { showCursor, isDragging, setShowCursor, setIsDragging } = useContext(
//     DatabaseDropdownContext
//   );
//   const [activeField, setActiveField] = useState(null);
//   const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

//   const editableCells = useRef([]);

//   useEffect(() => {
//     editableCells.current = tableData.cells.map((row) =>
//       row.map(() => React.createRef())
//     );
//   }, [tableData]);

//   const onCellChange = (rowIndex, colIndex, newHTML) => {
//     const updated = { ...tableData };
//     updated.cells[rowIndex][colIndex].content = newHTML;
//     onUpdateTable(updated);
//   };

//   // for ANY editable field
//   const handleDragOver = (e, rowIndex, colIndex) => {
//     e.preventDefault();
//     setActiveField({ row: rowIndex, col: colIndex });
//     setShowCursor(true);

//     const td = editableCells.current[rowIndex][colIndex].current;
//     const rect = td.getBoundingClientRect();

//     setCursorPosition({
//       x: e.clientX - rect.left,
//       y: e.clientY - rect.top,
//     });
//   };

//   const handleDragLeave = () => setShowCursor(false);

//   const handleDrop = (e, rowIndex, colIndex) => {
//     e.preventDefault();
//     setShowCursor(false);
//     setIsDragging(false);

//     const text = e.dataTransfer.getData("text/plain");
//     const td = editableCells.current[rowIndex][colIndex].current;

//     const range = document.caretRangeFromPoint(e.clientX, e.clientY);

//     if (range) {
//       const sel = window.getSelection();
//       sel.removeAllRanges();
//       sel.addRange(range);

//       const node = document.createTextNode(text + " ");
//       range.insertNode(node);
//       range.setStartAfter(node);
//       range.setEndAfter(node);
//       sel.removeAllRanges();
//       sel.addRange(range);
//     }

//     td.focus();
//   };

//   return (
//     <table role="presentation" width="100%" cellSpacing="0" cellPadding="0">
//       <tbody>
//         <tr>
//           <td align={tableData?.tableStyle?.align}>
//             <table
//               role="presentation"
//               cellSpacing="0"
//               cellPadding="0"
//               style={{
//                 width: tableData?.tableStyle?.width,
//                 background: tableData?.tableStyle?.backgroundColor,
//                 borderCollapse: "collapse",
//                 border: tableData?.tableStyle?.border,
//               }}
//             >
//               <tbody>
//                 {tableData.cells.map((row, rowIndex) => (
//                   <tr key={rowIndex}>
//                     {row.map((cell, colIndex) => (
//                       <td
//                         key={colIndex}
//                         ref={editableCells.current[rowIndex][colIndex]}
//                         contentEditable
//                         suppressContentEditableWarning={true}
//                         onClick={() => {
//                           setIndexRow(rowIndex);
//                           setIndexColumn(colIndex);
//                         }}
//                         onBlur={(e) =>
//                           onCellChange(rowIndex, colIndex, e.target.innerHTML)
//                         }
//                         onDragOver={(e) =>
//                           handleDragOver(e, rowIndex, colIndex)
//                         }
//                         onDragLeave={handleDragLeave}
//                         onDrop={(e) => handleDrop(e, rowIndex, colIndex)}
//                         style={{
//                           padding: cell?.style?.padding,
//                           border: cell?.style?.border,
//                           color: cell?.style?.color,
//                           fontSize: cell?.style?.fontSize,
//                           textAlign: cell?.style?.textAlign,
//                           backgroundColor: cell?.style?.backgroundColor,
//                           fontWeight: cell?.style?.fontWeight,
//                         }}
//                         dangerouslySetInnerHTML={{ __html: cell.content }}
//                       />
//                       {showCursor && isDragging && (activeField.row === rowIndex && activeField.col === colIndex) && (
//                         <div
//                           className="absolute pointer-events-none"
//                           style={{
//                             left: cursorPosition.x,
//                             top: cursorPosition.y,
//                             width: "3px",
//                             height: "22px",
//                             backgroundColor: "#6366f1",
//                             borderRadius: "2px",
//                           }}
//                         />
//                       )}
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </td>
//         </tr>
//       </tbody>
//     </table>
//   );
// }



import React, { useContext, useEffect, useRef, useState } from "react";
import { TableRowColumnIndexContex } from "../../../context/TableRowColumnIndexContex";
import { DatabaseDropdownContext } from "../../../context/DatabaseDropdownContext";
import { TextEditorContext } from "../../../context/TextEditorContext";

export default function TableComponent({ tableData, onUpdateTable }) {
  const { setIndexRow, setIndexColumn, savedRangeRef } = useContext(TableRowColumnIndexContex);

  const { showCursor, isDragging, setShowCursor, setIsDragging } = useContext(
    DatabaseDropdownContext
  );
  const { setIsTextSelected } = useContext(TextEditorContext);
  const [activeField, setActiveField] = useState(null);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  const editableCells = useRef([]);

  useEffect(() => {
    editableCells.current = tableData.cells.map((row) =>
      row.map(() => React.createRef())
    );
  }, [tableData]);

  const saveSelectionforAcnchor = () => {
      const sel = window.getSelection();
      if (sel.rangeCount > 0) {
        savedRangeRef.current = sel.getRangeAt(0).cloneRange();
        const text = sel.toString().trim();

        // tell context whether text is selected
        if (text.length > 0) {
          setIsTextSelected(true);
        } else {
          setIsTextSelected(false);
        }
      }
    };

  const onCellChange = (rowIndex, colIndex, newHTML) => {
    const updated = { ...tableData };
    updated.cells[rowIndex][colIndex].content = newHTML;
    onUpdateTable(updated);
  };

  const handleDragOver = (e, rowIndex, colIndex) => {
    e.preventDefault();
    setActiveField({ row: rowIndex, col: colIndex });
    setShowCursor(true);

    const td = editableCells.current[rowIndex]?.[colIndex]?.current;
    if (!td) return;
    
    const rect = td.getBoundingClientRect();

    setCursorPosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  const handleDragLeave = () => {
    setShowCursor(false);
  };

  const handleDrop = (e, rowIndex, colIndex) => {
    e.preventDefault();
    setShowCursor(false);
    setIsDragging(false);

    const text = e.dataTransfer.getData("text/plain");
    const td = editableCells.current[rowIndex]?.[colIndex]?.current;
    
    if (!td) return;

    const range = document.caretRangeFromPoint(e.clientX, e.clientY);

    if (range) {
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);

      const node = document.createTextNode(text + " ");
      range.insertNode(node);
      range.setStartAfter(node);
      range.setEndAfter(node);
      sel.removeAllRanges();
      sel.addRange(range);
      
      // Update the content after insertion
      onCellChange(rowIndex, colIndex, td.innerHTML);
    }

    td.focus();
  };

  return (<>
    {/* <div style={{ position: 'relative' }}> */}
      <table role="presentation" width="100%" cellSpacing="0" cellPadding="0">
        <tbody>
          <tr>
            <td align={tableData?.tableStyle?.align}>
              <table
                role="presentation"
                cellSpacing="0"
                cellPadding="0"
                style={{
                  width: tableData?.tableStyle?.width,
                  background: tableData?.tableStyle?.backgroundColor,
                  borderCollapse: "collapse",
                  border: tableData?.tableStyle?.border,
                }}
              >
                <tbody>
                  {tableData.cells.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {row.map((cell, colIndex) => (
                        <td
                          key={colIndex}
                          ref={editableCells.current[rowIndex]?.[colIndex]}
                          contentEditable
                          suppressContentEditableWarning={true}
                          onClick={() => {
                            setIndexRow(rowIndex);
                            setIndexColumn(colIndex);
                          }}
                          onBlur={(e) =>
                            onCellChange(rowIndex, colIndex, e.target.innerHTML)
                          }
                          onDragOver={(e) =>
                            handleDragOver(e, rowIndex, colIndex)
                          }
                          onDragLeave={handleDragLeave}
                          onDrop={(e) => handleDrop(e, rowIndex, colIndex)}
                          onKeyUp={saveSelectionforAcnchor}
                          onMouseUp={saveSelectionforAcnchor}
                          style={{
                            padding: cell?.style?.padding,
                            border: cell?.style?.border,
                            color: cell?.style?.color,
                            fontSize: cell?.style?.fontSize,
                            textAlign: cell?.style?.textAlign,
                            backgroundColor: cell?.style?.backgroundColor,
                            fontWeight: cell?.style?.fontWeight,
                            position: 'relative',
                          }}
                          dangerouslySetInnerHTML={{ __html: cell.content }}
                        />
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Cursor indicator OUTSIDE the table
      {showCursor && isDragging && activeField && (
        <div
          className="pointer-events-none"
          style={{
            position: 'fixed',
            left: cursorPosition.x + 'px',
            top: cursorPosition.y + 'px',
            width: '3px',
            height: '22px',
            backgroundColor: '#6366f1',
            borderRadius: '2px',
            boxShadow: '0 0 8px rgba(99, 102, 241, 0.6)',
            zIndex: 9999,
            animation: 'blink 1s infinite',
          }}
        />
      )}

      <style>{`
        @keyframes blink {
          0%, 49% { opacity: 1; }
          50%, 100% { opacity: 0.3; }
        }
      `}</style> */}
    {/*</div>*/}
    </>
  );
}

